import { createContext, useContext } from 'react';

export interface HomeBannerContextType {
  open: boolean;
  setOpen: (o: boolean) => void;
  hasDismissedBannerId: (id: string) => boolean;
  dismissBannerId: (id: string) => void;
  checkAndSet48HrBannerExpiration: (id: string) => Promise<void>;
  isLoadingHomeBannerState: boolean;
}
export const HomeBannerContext = createContext<HomeBannerContextType | undefined>(undefined);

export const useHomeBanner = () => {
  const context = useContext(HomeBannerContext);
  if (!context) {
    if (import.meta.env.PROD) throw new Error('useAuth must be used within an AuthProvider');
    console.warn(
      'No auth provider. This is a common side effect of HMR but is indicative of poor rendering optimization',
    );
    return {} as HomeBannerContextType;
  }
  return context;
};
